import { Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Carrier } from '@/types';
import { normalizeToTranslationKey } from '@/utils';
import { SectionHeader } from './SectionHeader';
import { SummaryRow } from './SummaryRow';

// NOTE: Est. Delivery date is not available from the current API response.
// A `estimated_delivery_at` field will be needed on the Carrier/Order response to populate this row.

interface CarrierSectionProps {
  carrier: Carrier | null;
}

export function CarrierSection({ carrier }: CarrierSectionProps) {
  const { t } = useTranslation();

  const initials = carrier?.title
    ? carrier.title
        .split(' ')
        .slice(0, 2)
        .map((w) => w[0])
        .join('')
        .toUpperCase()
    : '';

  return (
    <div className='rounded-2xl border border-sd-border bg-sd-card p-5'>
      <SectionHeader icon={Truck} title={String(t('carrier'))} />

      {carrier ? (
        <div className='divide-y divide-sd-border'>
          <div className='flex items-center gap-3 pb-2'>
            <div className='h-10 w-10 rounded-xl border border-sd-border flex items-center justify-center shrink-0 p-1.5'>
              {carrier.avatar?.abs_url ? (
                <img
                  src={carrier.avatar.abs_url}
                  alt={carrier.title}
                  className='h-full w-full object-contain'
                />
              ) : (
                <span className='text-xs font-bold text-sd-muted-foreground'>{initials}</span>
              )}
            </div>
            <span className='text-sm font-semibold text-sd-foreground'>
              {String(t(normalizeToTranslationKey(carrier.title)))}
            </span>
          </div>
          {/* Bug 10: Estimated delivery hidden — API doesn't provide this data yet */}
        </div>
      ) : (
        <p className='text-sm text-sd-muted-foreground'>
          {String(t('carrierHoverCell.noCarrierAssigned'))}
        </p>
      )}
    </div>
  );
}
